import Input from "components/common/Input";
import SearchIcon from "components/icons/SearchIcon";
import Button from "components/common/Button";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";
import s from "../../../styles/TopMenu.styles";

function TopMenu({ changeSearchValue, addCategory, loading }) {
  const { t } = useTranslation();
  return (
    <s.Container
      style={{
        display: "block",
      }}
    >
      <s.Title>
        {t("components.InventoryVariants.TopMenu.searchVariants")}
      </s.Title>
      <s.BottomContainer
        style={{
          marginBottom: "10px",
        }}
      >
        <Input
          disabled={loading}
          placeholder={t("components.InventoryVariants.TopMenu.search")}
          style={{
            marginBottom: "7px",
            maxWidth: "365px",
          }}
          prefix={<SearchIcon />}
          onChange={(e) => changeSearchValue(e.target.value)}
        />
        <s.BottomRightItemsContainer>
          <Button
            disabled={loading}
            type="primary"
            style={{
              background: Colors.primary,
              color: Colors.text_on_secondary,
              width: "none",
              fontWeight: "500",
              border: "none",
              height: "40px",
              marginBottom: "7px",
            }}
            onClick={() => addCategory()}
          >
            {t("components.InventoryVariants.TopMenu.addVariant")}
          </Button>
        </s.BottomRightItemsContainer>
      </s.BottomContainer>
    </s.Container>
  );
}

export default TopMenu;
